import { ReactNode } from 'react';

export const WithoutSidebarShell = ({ children }: { children: ReactNode }) => (
  <div className='bg-primary min-h-screen'>
    <div className='max-w-7xl mx-auto pt-8 md:pt-14'>{children}</div>
  </div>
);
